import { useEffect, useMemo, useState} from "react";
import useFetch from "./useFetch";
import { CircularProgress } from "@mui/material";
import hbricon from "./otherImg/hbrlitenewicon.png";
import AudioBookListContent from "./newComponents/AudioBookListContent";
import { realTimeDB } from "./firebase";
import { get, ref } from "firebase/database";
import { PurifyTextUtils } from "./newComponents/GeneralClasses";
import { Hbrbackarrow, HbrCancel, HbrSearchIcon } from "./newComponents/Mycustomsvgicons";
import { useLocation, useNavigate } from "react-router-dom";
import UseLayout from "./newComponents/useLayout";

const AudioBooks = () => {
    const [searchAudioBook,setSearchAudioBook] = useState('');
    const [showSearch,setShowSearch]=useState(false);
    const [audioBooks,setAudioBooks]=useState([]);
    const navigate = useNavigate();
    const location = useLocation();
    const {width} = UseLayout();
    const {data: audioInfo,ispending,erroralert} = useFetch(`${process.env.REACT_APP_BOOKS_SERVER_URL}/audiobooks`);
    // const {data: audioInfo,ispending,erroralert} = useFetch(`http://localhost:3500/audiobooks`);

   
    useEffect(()=>{
        async function getBookAnalytics() {
          if (audioInfo) {
            const bookStatsSnapshot = await get(ref(realTimeDB,"audioBookStats"));
            const bookStatsData = bookStatsSnapshot.val();
    
            const arrayOfBooks = Object.keys(audioInfo).map((key)=>({
              id: key,
    
              ...audioInfo[key],
    
              stream: bookStatsData[PurifyTextUtils(audioInfo[key].title)+" - Audio book 🎧"]?.stream ? bookStatsData[PurifyTextUtils(audioInfo[key].title)+" - Audio book 🎧"].stream : 0,
    
              shares: bookStatsData[PurifyTextUtils(audioInfo[key].title)+" - Audio book 🎧"]?.shares ? bookStatsData[PurifyTextUtils(audioInfo[key].title)+" - Audio book 🎧"].shares : 0,
    
              downloads: bookStatsData[PurifyTextUtils(audioInfo[key].title)+" - Audio book 🎧"]?.downloads ? bookStatsData[PurifyTextUtils(audioInfo[key].title)+ " - Audio book 🎧"].downloads : 0,
    
              rate: bookStatsData[PurifyTextUtils(audioInfo[key].title)+" - Audio book 🎧"]?.rate ? bookStatsData[PurifyTextUtils(audioInfo[key].title)+" - Audio book 🎧"].rate : 0
            }));
      
            const sortedBooks = arrayOfBooks?.sort((a,b) => b.stream - a.stream);
            setAudioBooks(sortedBooks);
          }
        }
        getBookAnalytics();
    },[audioInfo]);

    const memoizedAudioBooks = useMemo(()=>audioBooks, [audioBooks]);

    const handleClosePage=()=>{
      if (location.state && location.state.from) {
          navigate(location.state.from);
      }else{
          navigate("/");
      }
  };


    return ( 
        <div className="audiobookclass">
          {erroralert && 
          <div style={{
            position:"absolute",
            left:"50%",
            top:"30%"
            }}
          >
            <h3>{erroralert}</h3>
          </div>}

          {ispending &&
            <div style={{
                position:"absolute",
                left:"50%",
                top:"30%"
                }}> 
             <CircularProgress/> <br/>
            loading...
            </div>
            } 

         
          <div className="search-field-audiobooks">
          <Hbrbackarrow width={"1.8em"} height={"1.8em"} fillColour={"black"} handleClick={() => handleClosePage()}/>
            <h4> Audio Bks <span style={{color:"orangered"}}>{audioInfo && audioInfo.length}</span></h4>
            <input type="search" placeholder="search for audio book by name" onChange={e => setSearchAudioBook(e.target.value)}/> 
        
            <div className="pagetoplogo flex-row2">
                <h4 style={{color:"teal"}}>hbr<span style={{color:"orangered",fontWeight:"bold"}}>LiTE</span></h4> 
                <img src={hbricon} alt=""/>
            </div>
          </div> 

            { width <= 1025 &&
                    <div className="search-field-phone" style={{width:"100%"}}>

                    <Hbrbackarrow width={"1.8em"} height={"1.8em"} fillColour={"black"} handleClick={() => handleClosePage()}/>
                     
                      {!showSearch && 
                         <div className="pagetoplogo flex-row2">
                            <img src={hbricon} alt=""/>
                            <h4 style={{color:"teal"}}>hbr<span style={{color:"orangered",fontWeight:"bold"}}>LiTE</span></h4> 
                        </div>
                      } 
    
                      {showSearch ?
                        <div className="flex-spacearound" style={{width:"100%"}}>
                          <input type="search" placeholder="search" onChange={e => setSearchAudioBook(e.target.value)}/> 
                          <HbrCancel width={"1.6em"} height={"1.6em"} fillColour={"black"} handleClick={()=>setShowSearch(false)}/>
                        </div> 
                        :
                        <HbrSearchIcon width={"1.6em"} height={"1.6em"} fillColour={"black"} handleClick={()=>setShowSearch(true)}/>
                      }
                      
              </div>
            }
      
         
         <div className="audiobookdatacompmain" >
        
            {memoizedAudioBooks && memoizedAudioBooks.filter((audioData)=>{
              if(searchAudioBook === ""){
                return true;
              }else if(audioData.title.replace(/[^\w\s]|_/g, '').toLowerCase().includes(searchAudioBook.toLowerCase())){
                  return true;
              }
                return false;

            }).map((audioData) => (
                <AudioBookListContent
                  key={audioData._id}
                  audiobookTitle={audioData.title}
                  audioBookImage={audioData.image}
                  audiobookID={audioData._id}
                  stream={audioData.stream}
                  rate={audioData.rate}
                  downloads={audioData.downloads}
                  shares={audioData.shares}
                />
              ))}
       </div>

        </div>
     );
}
 
export default AudioBooks;